module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"positionExport":"Export position","remove":"Remove","text":"Text","title":"Title","suggest":"Suggest"}}')
  delete Component.options._Ctor
}
